import { sql } from 'drizzle-orm';
import { pgPolicy, pgRole } from 'drizzle-orm/pg-core';

/**
 * Application role with RLS enforced. Created in the database by
 * `infra/docker/init-db.sql` (local) or infrastructure provisioning (prod).
 * Using `.existing()` tells Drizzle the role is managed externally.
 */
export const kikuApp = pgRole('kiku_app').existing();

/**
 * RLS policy: rows visible only when tenant_id matches the session variable.
 * Returns a new policy instance per call — PostgreSQL policy names are table-scoped,
 * so each table gets its own policy object to avoid Drizzle's "not linked" warning.
 */
export function tenantIsolationPolicy(): ReturnType<typeof pgPolicy> {
  return pgPolicy('tenant_isolation', {
    as: 'permissive',
    for: 'all',
    to: kikuApp,
    using: sql`tenant_id = current_setting('app.tenant_id', true)::uuid`
  });
}

/**
 * RLS policy: rows visible only when both tenant_id and org_id match session variables.
 * Returns a new policy instance per call — see {@link tenantIsolationPolicy}.
 */
export function tenantOrgIsolationPolicy(): ReturnType<typeof pgPolicy> {
  return pgPolicy('tenant_org_isolation', {
    as: 'permissive',
    for: 'all',
    to: kikuApp,
    using: sql`tenant_id = current_setting('app.tenant_id', true)::uuid AND org_id = current_setting('app.org_id', true)::uuid`
  });
}
